var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButtonRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85178 19.1283C6.59143 18.8679 6.59143 18.4458 6.85178 18.1855L18.1655 6.87175C18.4258 6.6114 18.8479 6.6114 19.1083 6.87175C19.3686 7.1321 19.3686 7.55421 19.1083 7.81456L7.79458 19.1283C7.53424 19.3886 7.11213 19.3886 6.85178 19.1283Z",
    fill: "#EC494F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85184 6.8718C7.11219 6.61145 7.5343 6.61145 7.79465 6.8718L19.1084 18.1855C19.3687 18.4459 19.3687 18.868 19.1084 19.1283C18.848 19.3887 18.4259 19.3887 18.1655 19.1283L6.85184 7.8146C6.59149 7.55425 6.59149 7.13214 6.85184 6.8718Z",
    fill: "#EC494F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButtonRed);
export default __webpack_public_path__ + "static/media/close-button-red.03557b03d8fa40923a073bee6e98248e.svg";
export { ForwardRef as ReactComponent };